<button appGoBack class="c-button">
  <img class="c-button__img">
  <p class="c-button__text">Voltar</p>
</button>
